import { useEffect, useState } from 'react';
import { api, Customer, Issue } from './api';
import { softphone } from '../softphone/streams';

export function CustomerView({ customerId, onChanged }: { customerId: string; onChanged?: () => void }) {
  const [c, setC] = useState<Customer | null>(null);
  const [title, setTitle] = useState('');
  const [summary, setSummary] = useState('');
  const load = () => api.getCustomer(customerId).then(setC);
  useEffect(() => { load(); }, [customerId]);
  if (!c) return <p>Loading…</p>;

  const createIssue = async () => {
    if (!title.trim()) return;
    await api.createIssue(c.id, { title, summary });
    setTitle(''); setSummary('');
    await load(); onChanged?.();
  };
  const setStatus = async (i: Issue, status: Issue['status']) => { await api.updateIssue(c.id, i.id, { status }); await load(); };

  return (
    <div className="customer">
      <h2>{c.name} {c.company && <small>· {c.company}</small>}</h2>
      <div className="contacts">
        {c.phones.map((p) => <button key={p} onClick={() => softphone.dial(p)}>Call {p}</button>)}
        {c.emails.map((e) => <span key={e} className="pill">{e}</span>)}
      </div>

      <h3>Issues</h3>
      <div className="new-issue">
        <input placeholder="Issue title" value={title} onChange={(e) => setTitle(e.target.value)} />
        <textarea placeholder="Summary" value={summary} onChange={(e) => setSummary(e.target.value)} />
        <button onClick={createIssue}>Log issue</button>
      </div>
      <ul className="issues">
        {(c.issues ?? []).map((i) => (
          <li key={i.id} className={`issue issue-${i.status}`}>
            <div><strong>{i.title}</strong> <span className="pill">{i.status}</span> <span className="pill">{i.priority}</span></div>
            <p>{i.summary}</p>
            <div className="row">
              {i.status !== 'closed' && <button onClick={() => setStatus(i, 'closed')}>Close</button>}
              {i.status === 'open' && <button onClick={() => setStatus(i, 'pending')}>Pending</button>}
              {i.status !== 'open' && <button onClick={() => setStatus(i, 'open')}>Reopen</button>}
            </div>
          </li>
        ))}
      </ul>

      <h3>Timeline</h3>
      <ul className="timeline">
        {(c.interactions ?? []).map((t) => (
          <li key={t.SK}>
            <span className="when">{new Date(t.createdAt).toLocaleString()}</span>
            <span className="pill">{t.type}</span>
            {t.durationSec != null && <span>{t.durationSec}s</span>}
            {t.subject && <span>{t.subject}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
